import React from 'react';
import { AiOutlineDownload } from 'react-icons/ai';
import './header.css';
import { useTranslation } from '../../contexts/TranslationContext';

const CTA = () => {
  const { t, language } = useTranslation();
  const CV = language === 'en' 
    ? '/CV_BRUSCHI_Tanguy.pdf' 
    : '/CV_BRUSCHI_Tanguy.pdf';
  
  return (
    <div className='cta'>
      <div className="hover-2">
        <a href={CV} download className='btnCV'>
          <AiOutlineDownload className='DownloadIcon' />
          {t('cta.cv')}
        </a>
      </div>
    </div>
  ) 
}

export default CTA